<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16fklBn/tc-custom/9780062568366.jpg?1716662593336" alt="This image is the cover for the book Wishbreaker, Wishmakers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wishbreaker, Wishmakers
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Ace and Ridge are back to save their friend—and the world—in this sequel to <i>The Wishmakers</i>, which Chris Grabenstein, #1 <i>New York Times</i> bestselling author of <i>Escape from Mr. Lemoncello’s Library</i>, praised as a “fantastically fast-paced and funny read.”</b></p><p>Being a Wishmaker may be more trouble than it’s worth. Sure, you get a genie who can grant an unlimited number of wishes, but for each one you make you have to accept an awful consequence in return. Not to mention that you’re also given an impossible quest and only seven days to fulfill it!</p><p>Despite all that, Ace and his genie, Ridge, managed to complete their last mission—but they couldn’t save their friend Tina from being abducted by a rogue genie who’s bent on using his limitless power to rule the world. To rescue her, Ace must reunite with Ridge to become a Wishmaker once more, and they’ll need to team up with the unlikeliest of new allies. It’s not every day you get a second chance to save the world, so Ace is determined to learn from his past mistakes and wish for the best, literally.</p><p>Perfect for fans of Max Brailler, Adam Gidwitz, and Dan Gutman, this middle grade series is a wonderful mix of unpredictable magic, zany humor, and daring adventure. “An ingenious premise” raved <i>Kirkus</i> in a starred review!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tyler Whitesides
      </h2>
      
      <p class="authorDescription body article">Taylor Whitesides&#160;always wished to be an author. Somehow he accomplished it without the help of a genie and wrote the acclaimed Janitors and Wishmakers series. When he&#8217;s not writing, Tyler loves eating good food, playing drums, and fishing. He lives in northern Utah with his wife and son. Visit him online at www.tylerwhitesides.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9cf7fef6